// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28OMv","left":"styles_left__1wG4U"};